import { useContext } from "react";
import Button from "../components/Button";
import { ReactComponent as IllusStep } from "../img/illustrations/conso.svg";
import { useSwiper } from "swiper/react";
import SimulationContext from "../contexts/Simulation";

import { ReactComponent as IconLeft } from "../img/left.svg";
import { ReactComponent as IconRight } from "../img/right.svg";
import TextInput from "../components/TextInput";
import { useEffect, useState } from "react";

const ConsoHelper = ({ month, setConso }) => {
  const [value, setValue] = useState('');
  const [touched, setTouched] = useState(false);

  const handleLeft = () => {
    setValue(Math.max((value || 0) - 100, 0));
  };

  const handleRight = () => {
    setValue(Math.min((value || 0) + 100, 5000));
  };

  const handleChange = (e) => {
    if (e.target.value.match(/^[0-9]*$/) && ((parseInt(e.target.value) <= 5000) || e.target.value === ''))
    {
      setValue((e.target.value !== '') ? parseInt(e.target.value) : '');
    }
  };

  useEffect(() => {
    if (!touched)
    {
      setTouched(true);
      return;
    }
    setConso(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="conso_helper">
      <div className="month">{ month }</div>
      <div className="selector">
        <IconLeft className="arrow left" onClick={handleLeft}/>
        <div className="input">
          <div class="kwh">kWh</div>
          <TextInput variant="conso" placeholder="0000" value={value} onchange={handleChange}/>
        </div>
        <IconRight className="arrow right" onClick={handleRight}/>
      </div>
    </div>
  )
}

const ConsoStep = ({ step }) => {
  const [simParams, setSimParams] = useContext(SimulationContext);
  const swiper = useSwiper();
  const [consos, setConsos] = useState([null, null, null]);

  const setConso = (index, value) => {
    consos[index] = value;
    var valid = true;
    consos.forEach((c) => { if (isNaN(parseInt(c))) valid = false });

    setSimParams({
      ...simParams, 
      consos: consos, 
      allowSlideNext: valid, 
      validSteps: (simParams.validSteps & ~(1 << step)) | (valid << step)
    });
    setConsos(consos);
  };

  return (
    <div className="content conso">
      <IllusStep className="main-illus"/>
      <h3>Il affiche combien, votre compteur ?</h3>
      <div className="sub">Pour affiner votre simulation, on a juste besoin de quelques chiffres clés. Attrapez votre dernière facture EDF et renseignez votre conso d'électricité sur trois périodes.</div>
      <div className="consos">
        <ConsoHelper month="Janvier" setConso={(val) => setConso(0, val)}/>
        <ConsoHelper month="Mars" setConso={(val) => setConso(1, val)}/>
        <ConsoHelper month="Juin" setConso={(val) => setConso(2, val)}/>
      </div>
      <div className="sub">Plus c'est précis, plus l'estimation sera juste.</div>
      <Button variant='yellow' onclick={() => swiper.slideNext()}>Valider ma conso</Button>
    </div>
  )
}

export default ConsoStep;